import styled from "styled-components";
import { Link, NavLink } from "react-router-dom";

export const HeaderSection = styled.header`
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0.8rem 0;
  border-bottom: 1px solid color-mix(in srgb, var(--border-color) 72%, transparent);
  background: color-mix(in srgb, var(--surface) 88%, transparent);
  backdrop-filter: blur(18px) saturate(160%);

  .header-inner {
    display: flex;
    min-height: 52px;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
  }
`;

export const LogoContainer = styled(Link)`
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  width: 148px;
  height: 46px;
  overflow: hidden;
  border-radius: 10px;

  img {
    position: absolute;
    top: -36px;
    left: 0;
    width: 148px;
    height: 148px;
    object-fit: contain;
  }

  [data-theme="dark"] & {
    background: rgba(255, 255, 255, 0.96);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
  }
`;

export const DesktopNav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;

  @media (max-width: 980px) {
    display: none;
  }
`;

export const NavItem = styled(NavLink)`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0.65rem 0.8rem;
  border-radius: 10px;
  color: var(--text-secondary);
  font-size: 0.93rem;
  font-weight: 600;
  transition: color 0.2s ease, background 0.2s ease;

  &:hover,
  &.active {
    color: var(--text-primary);
    background: var(--surface-alt);
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.55rem;

  @media (max-width: 980px) {
    display: none;
  }
`;

export const LanguageSelect = styled.select`
  display: inline-block;
  width: 58px;
  height: 42px;
  padding: 0 0.45rem;
  border: 1px solid var(--border-color);
  border-radius: 11px;
  background: var(--surface);
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  cursor: pointer;
  appearance: auto;

  &:hover {
    border-color: var(--secondary-teal);
    color: var(--secondary-teal);
    background: var(--secondary-teal-soft);
  }
`;

const ActionLink = styled.a`
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 1.05rem;
  border-radius: 11px;
  font-size: 0.9rem;
  font-weight: 700;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }
`;

export const SecondaryAction = styled(ActionLink)`
  border: 1px solid var(--border-strong);
  background: var(--surface);
  color: var(--text-primary);

  &:hover {
    border-color: var(--primary-blue);
    color: var(--primary-blue);
  }
`;

export const PrimaryAction = styled(ActionLink)`
  border: 1px solid var(--primary-blue-deep);
  background: var(--primary-blue-deep);
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(8, 28, 67, 0.18);

  &:hover {
    background: var(--secondary-teal);
    border-color: var(--secondary-teal);
    color: #ffffff;
    box-shadow: 0 10px 24px rgba(14, 159, 141, 0.25);
  }
`;

export const MenuButton = styled.button`
  display: none;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: var(--surface);
  color: var(--text-primary);
  font-size: 1.25rem;
  cursor: pointer;

  @media (max-width: 980px) {
    display: inline-flex;
  }
`;

export const MobileNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  ${NavItem} {
    width: 100%;
    padding: 0.9rem 1rem;
    font-size: 1.05rem;
  }
`;

export const MobileActions = styled.div`
  display: grid;
  gap: 0.75rem;
  margin-top: auto;
  padding-top: 2rem;

  > div {
    margin-bottom: 0.75rem;
  }

  ${LanguageSelect} {
    width: 100%;
  }

  @media (max-width: 640px) {
    padding-bottom: 4.5rem;
  }
`;
